export const RECORDS_TABLE_ID = {
  BTN_EXPORT_DATA: 'btnExportData',
  IPT_EXPORT_FILE_TYPE: 'iptExportFileType',
  LST_EXPORT_FILE: 'lstExportFileType',
};
